import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
// eslint-disable-next-line camelcase
import { LEGACY_sendMessage } from '../../utils/legacy';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

const S3Plugin = React.lazy(() => importFromS3('tcc-reports-plugin'));

export const ReportsPluginContainer = ({ operationsSelected }: { operationsSelected: Operation[] }) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.reportsPlugin.module-federation'];

  const ReportsPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('tccReportsPlugin/TccReportsPlugin'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return (
    <ReportsPlugin
      // eslint-disable-next-line camelcase
      sendMessage={LEGACY_sendMessage}
      operationsSelected={operationsSelected}
      shouldRenderFarmerNav={false}
    />
  );
};
